export default "__VITE_ASSET__DY33F0EZ__"